/* eslint-disable react/no-unescaped-entities */
import React from "react";

export const AssertionCriteriaMethodHelp = () => {
  return (
    <div>
      Name of assertion method - A short name for your assertion criteria that
      you want displayed on the ClinVar website, e.g.:
      <ul>
        <li>Germline Variant Classification Guidelines, 2015</li>
        <li>MyTestingLab Classification</li>
      </ul>
    </div>
  );
};

export const AssertionCriteriaCitationMethodHelp = () => {
  return (
    <ul>
      <li>
        It may be a single citation, URL, or file name, e.g.
        <ul>
          <li>PMID 25741868</li>
          <li>www.MyTestingLab.com/classification/</li>
          <li>MyTestingLab_Classification.docx</li>
        </ul>
      </li>
      <li>
        If it's a file, send that file to ClinVar by email in order to get a
        citation url.
      </li>
    </ul>
  );
};
